import { Component, Input, OnChanges } from '@angular/core';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
import { AuthService } from 'src/app/services/auth/auth.service';

/**
 * EL AVISO DE PAGO DE UNA LIQUIDACIÓN (cambio 12; AVI-07, 08, 12). Su estado, a quién salió y cada intento; «Reenviar
 * aviso» en el momento (Mario, 11-oct), con motivo, al mismo destinatario u otro correo y con el mismo PDF; y «Probar la
 * cuenta de correo» con un aviso de ejemplo a una dirección @hazling.com. Sin diálogos.
 */
const ESTADOS: Record<string, { texto: string; clase: string }> = {
  POR_ENVIAR: { texto: 'Por enviar', clase: 'kb-badge-alerta' },
  ENVIADO: { texto: 'Enviado', clase: 'kb-badge-exito' },
  SIN_DESTINATARIO: { texto: 'Sin destinatario', clase: 'kb-badge-alerta' },
  FALLIDO: { texto: 'No se pudo enviar', clase: 'kb-badge-peligro' },
};

@Component({
  selector: 'app-liquidacion-aviso',
  templateUrl: './liquidacion-aviso.component.html'
})
export class LiquidacionAvisoComponent implements OnChanges {
  @Input() liquidacion = '';

  cargando = false;
  error = '';
  a: any = null;
  sinAviso = false;

  reenviando = false;
  motivo = '';
  otroCorreo = '';
  ocupado = false;
  resultado: { ok: boolean; texto: string } | null = null;

  probando = false;
  correoPrueba = '';
  resultadoPrueba: { ok: boolean; texto: string } | null = null;

  constructor(private liq: LiquidacionService, public _auth: AuthService) { }

  get puedeReenviar(): boolean { return this._auth.hasPermission('liquidacion.avisos.reenviar'); }

  ngOnChanges(): void { this.cargar(); }

  cargar = async (): Promise<void> => {
    if (!this.liquidacion) return;
    this.cargando = true; this.error = ''; this.sinAviso = false;
    try { this.a = await this.liq.avisoDeLiquidacion(this.liquidacion); }
    catch (e: any) { if (e?.status === 404) this.sinAviso = true; else this.error = e?.error?.msg || 'No se pudo leer el aviso de pago.'; }
    finally { this.cargando = false; }
  };

  estado = (s: string): { texto: string; clase: string } => ESTADOS[s] || { texto: s, clase: 'kb-badge-neutro' };

  reenviar = async (): Promise<void> => {
    if (this.motivo.trim().length < 5) { this.resultado = { ok: false, texto: 'Para reenviar escribe el motivo (5 caracteres o más).' }; return; }
    this.ocupado = true; this.resultado = null;
    try {
      const r = await this.liq.reenviarAviso(this.liquidacion, this.motivo.trim(), this.otroCorreo.trim());
      this.resultado = { ok: true, texto: `Aviso reenviado a ${(r.intento?.para || []).join(', ')}${r.intento?.prueba ? ' (este ambiente redirige: es de prueba)' : ''}.` };
      this.reenviando = false; this.motivo = ''; this.otroCorreo = '';
    } catch (e: any) {
      const b = e?.error || {};
      this.resultado = { ok: false, texto: b.error ? `No salió: ${b.error}` : (b.msg || 'No se pudo reenviar el aviso.') };
    } finally { this.ocupado = false; await this.cargar(); }
  };

  probar = async (): Promise<void> => {
    if (!/^[^@\s]+@hazling\.com$/i.test(this.correoPrueba.trim())) { this.resultadoPrueba = { ok: false, texto: 'El correo de prueba solo va a una dirección @hazling.com.' }; return; }
    this.ocupado = true; this.resultadoPrueba = null;
    try {
      const r = await this.liq.correoDePrueba(this.correoPrueba.trim());
      this.resultadoPrueba = { ok: true, texto: `Correo de prueba enviado a ${r.para} desde ${r.remitente}. Revisa la bandeja (y el spam).` };
    } catch (e: any) {
      const b = e?.error || {};
      this.resultadoPrueba = { ok: false, texto: b.error ? `La cuenta de correo falló (${b.etapa || 'envío'}): ${b.error}` : (b.msg || 'No se pudo enviar el correo de prueba.') };
    } finally { this.ocupado = false; }
  };
}
